// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ee72f94","512":"47d5abb5","721":"ad536fe8"}[chunkId] + ".chunk.js";
};